export const TOKEN_COOKIE_KEY = 'token'
export const AUTH_COOKIE_KEY = 'auth-type'
